module.exports = __webpack_public_path__ + "static/media/lens.fcffa2eb.svg";